<template>
  <v-layout row wrap>
    <v-flex xs12 sm6 offset-sm3>
      <div v-for="coa in coaches" :key="coa.id" :id="coa.id" class="coach">
        <v-card>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-img :src="coa.photo" height="400px" contain></v-img>
              </v-flex>
              <v-flex xs12>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{ coa.name }}</h3>
                    <div class="subheading">{{ coa.clubPosition }}</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="body-1">
                    <span class="body-2">Стаж:</span>
                    {{ coa.experience }}
                  </div>
                  <v-divider></v-divider>

                  <div class="body-1">
                    <span class="body-2">Дан:</span>
                    {{ coa.dan }}
                  </div>
                  <v-divider></v-divider>

                  <div class="body-1">
                    <span class="body-2">Спортивная квалификация:</span>
                    {{ coa.sportsQualificationan }}
                  </div>
                  <v-divider></v-divider>

                  <div class="body-1">
                    <span class="body-2">Участие в соревнованиях:</span>
                    {{ coa.games }}
                  </div>
                  <v-divider></v-divider>

                  <div class="body-1">
                    <span class="body-2">Судейская квалификация:</span>
                    {{ coa.judge }}
                  </div>

                  <div class="body-1">
                    <span class="body-2">Телефон:</span>
                    
                    <a :href="tel(coa.phone)">{{ coa.phone }}</a>
                  </div>

                  <v-divider></v-divider>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-divider></v-divider>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import api from "../api";

export default {
  data() {
    return {
      error: "",
      coaches: []
    };
  },
  methods: {
    tel(phone) {
      return `tel:${phone}`;
    }
  },
  async created() {
    try {
      this.error = null;
      this.coaches = await api.getActiveCoaches();
    } catch (error) {
      this.error = error.response.data;
    }
  }
};
</script>

<style scoped>
.coach {
  margin-bottom: 20px;
}
</style>
